export default __webpack_public_path__ + "static/media/screen7.3025adf0.jpg";